module.exports = __webpack_public_path__ + "img/cancelAppointment.b01799b7.svg";